import React, { useState, useEffect } from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;
    const [selectedFromDate, setSelectedFromDate] = useState(null);
    const [selectedToDate, setSelectedToDate] = useState(null);
    const [dateError, setDateError] = useState(false);

    useEffect(() => {
        if (filtersModel.from_date) {
            setSelectedFromDate(new Date(filtersModel.from_date));
        }
        if (filtersModel.to_date) {
            setSelectedToDate(new Date(filtersModel.to_date));
        }
    }, [filtersModel]);

    const onStatusAdded = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, statuses: [...(prevState.statuses || []), selectedOption.id] }
        })
    }

    const onStatusRemove = (selectedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, statuses: prevState.statuses.filter((id) => id !== removedOption.id) }
        })
    }

    const handleFromDateChange = (date) => {
        if (date) {
            setDateError(false);
            let formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            setSelectedFromDate(date);

            setFiltersModel((prevState) => {
                return { ...prevState, from_date: formattedDate }
            })
        }
    }

    const handleToDateChange = (date) => {
        if (date) {
            if (selectedFromDate) {
                setDateError(false);
                let formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
                setSelectedToDate(date);

                setFiltersModel((prevState) => {
                    return { ...prevState, to_date: formattedDate }
                })
            }
            else {
                setDateError(true);
            }
        }
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
        <div>
            <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <MultiSelectField
                    options={[
                        {
                            id: 'deleted',
                            name: 'Deleted'
                        },
                        {
                            id: 'unpaid',
                            name: 'Unpaid'
                        },
                        {
                            id: 'approved',
                            name: 'Approved'
                        },
                        {
                            id: 'redeemed',
                            name: 'Redeemed'
                        },
                    ]}
                    fieldName="statuses"
                    stateModel={filtersModel}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onStatusAdded}
                    onRemove={onStatusRemove}
                />
            </Form.Group>
            <Form.Group className="mb-2">
                <Form.Label>From Date</Form.Label>
                <br />
                <DatePicker
                    selected={selectedFromDate}
                    dateFormat='dd/MM/yyyy'
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onChange={(date) => handleFromDateChange(date)}
                    placeholderText="Select From Date"
                    className="font-size-12"
                />
            </Form.Group>
            <Form.Group className="mb-2">
                <Form.Label>To Date</Form.Label>
                <br />
                <DatePicker stateModel={filtersModel}
                    selected={selectedToDate}
                    dateFormat='dd/MM/yyyy'
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onChange={(date) => handleToDateChange(date)}
                    placeholderText="Select To Date"
                    className="font-size-12"
                    minDate={selectedFromDate}
                />
            </Form.Group>
            {dateError && <div className='font-size-10 text-danger mb-2'>Please select from date first.</div>}
        </div>
    </Filters>
};

export default FiltersPartial;

